import React from 'react';
import {
  Box,
  TextField,
  Button,
  Paper,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  isLoading: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onSearch,
  isLoading,
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !isLoading) {
      onSearch();
    }
  };

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ position: 'relative', flexGrow: 1 }}>
          <SearchIcon sx={{ 
            position: 'absolute', 
            left: 12, 
            top: '50%', 
            transform: 'translateY(-50%)', 
            color: 'text.secondary', 
            zIndex: 1 
          }} />
          <TextField
            fullWidth
            placeholder='Ask anything about your leads... (e.g., tech companies in San Francisco or high priority leads needing follow-up)'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
            sx={{
              '& .MuiOutlinedInput-root': {
                paddingLeft: '40px',
              },
            }}
          />
        </Box>
        <Button
          variant='contained'
          color='primary'
          onClick={onSearch}
          disabled={!value.trim() || isLoading}
          sx={{ 
            minWidth: 120,
            color: '#ffffff !important',
            '& .MuiButton-label': {
              color: '#ffffff',
            },
          }}
        >
          {isLoading ? 'Searching...' : 'Search'}
        </Button>
      </Box>
    </Paper>
  );
};
